// Marca del producto y datos de la organización.
// Mientras la app sea de una sola organización, el nombre sale de variables de entorno.
// En la Fase 1 (multi-organización) estos datos pasan a leerse del registro de cada organización.
export const BRAND = {
  product: 'Gestión360',
  tagline: 'Control de personal',
  orgName: process.env.REACT_APP_ORG_NAME || 'Tu organización',
  orgLogo: '',
  orgColor: '',
  hideProduct: false,
  orgSub: process.env.REACT_APP_ORG_SUB || '',
};

// Color de la empresa: variables CSS que reemplazan el azul del producto (ver index.css, clase has-brand)
const hexOk = (c) => /^#[0-9a-fA-F]{6}$/.test(c || '');
const shade = (hex, k) => { const n = parseInt(hex.slice(1), 16); const f = (v) => Math.max(0, Math.min(255, Math.round(v * k))); return '#' + [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => f(v).toString(16).padStart(2, '0')).join(''); };
export const applyBrandTheme = (color) => {
  const root = document.documentElement;
  BRAND.orgColor = hexOk(color) ? color : '';
  if (!BRAND.orgColor) { root.classList.remove('has-brand'); ['--brand', '--brand-dark', '--brand-grad'].forEach((v) => root.style.removeProperty(v)); document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#222d5a'); return; }
  root.classList.add('has-brand');
  root.style.setProperty('--brand', color);
  root.style.setProperty('--brand-dark', shade(color, 0.6));
  root.style.setProperty('--brand-grad', `linear-gradient(135deg,${shade(color, 0.6)},${color})`);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', shade(color, 0.6));
};
